import { createSelector } from '@ngrx/store';

import { routeStateFeatureKey } from '@shared/reducers/route.reducer';

import { selectCoreModule } from './core.selector';

const routeState = createSelector(selectCoreModule, coreState => coreState[routeStateFeatureKey]);

export const selectPreviousRoute = createSelector(routeState, state => state.previousRoute);
